import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

let _prom = null;
export function useCifras() {
  const [c, setC] = useState(null);
  useEffect(() => {
    _prom = _prom || api.get("/portal/publico/cifras").then((r) => r.data).catch(() => { _prom = null; return null; });
    _prom.then(setC);
  }, []);
  return c;
}

export function useVisible(umbral = 0.2) {
  const ref = useRef(null);
  const [v, setV] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) { setV(true); return undefined; }
    const o = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setV(true); o.disconnect(); } }, { threshold: umbral });
    o.observe(el);
    return () => { o.disconnect(); };
  }, [umbral]);
  return [ref, v];
}

export function Revelar({ as: T = "div", d = 0, className = "", children, ...p }) {
  const [ref, v] = useVisible(0.15);
  return <T ref={ref} className={`cn-rev ${v ? "on" : ""} ${className}`} style={{ "--d": `${d}s` }} {...p}>{children}</T>;
}

export function Contador({ valor, ms = 1600, testid }) {
  const [ref, v] = useVisible(0.3);
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!v || valor == null) return undefined;
    let raf; const t0 = performance.now();
    const paso = (t) => { const k = Math.min(1, (t - t0) / ms); setN(Math.round(valor * (1 - (1 - k) ** 3))); if (k < 1) raf = requestAnimationFrame(paso); };
    raf = requestAnimationFrame(paso);
    return () => { cancelAnimationFrame(raf); };
  }, [v, valor, ms]);
  return <span ref={ref} data-testid={testid}>{valor == null ? "—" : n.toLocaleString("es-PY")}</span>;
}

export const CifraVidrio = ({ valor, etq, testid, d = 0 }) => <Revelar d={d} className="cn-vidrio" data-testid={testid}>
  <p className="cn-vidrio-n"><Contador valor={valor} testid={`${testid}-valor`} /></p>
  <p className="cn-vidrio-e">{etq}</p>
</Revelar>;

export function useParallax() {
  const ref = useRef(null);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    let raf;
    const f = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        el.style.setProperty("--py", `${((r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight) * -60}px`);
      });
    };
    f();
    window.addEventListener("scroll", f, { passive: true, capture: true });
    return () => { window.removeEventListener("scroll", f, { capture: true }); cancelAnimationFrame(raf); };
  }, []);
  return ref;
}
